import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  permits: "Permit.Permits",
  list: "Permit.PermitList",
  base: "Permit.PermitBase",
  view: "Permit.PermitView",
  documents: "Permit.PermitDocuments",
  documentsEdit: "Permit.PermitDocumentsEdit",
  documentsNew: "Permit.PermitDocumentsNew",
  notes: "Permit.PermitNotes",
  noteEdit: "Permit.PermitNoteEdit",
  noteNew: "Permit.PermitNoteNew",
  audit: "Permit.PermitAudit",
};

export { names as permitRouteNames };

const permitRoutes: RouterOptions["routes"] = [
  {
    path: "/permit",
    name: names.permits,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Permits",
          // lookupGroups: ["PermitType"],
        },
        component: () => import("@/views/permit/PermitList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/permit/PermitBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Permit View" },
            component: () => import("@/views/permit/PermitView.vue"),
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Permit Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="permit" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Permit Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="permit" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Permit Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="permit" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Permit Notes" },
            component: {
              render: () => <EntityNotes idField="permitId" routeNamePrefix="Permit.PermitNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Permit Note", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Permit Note", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Permit Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Permit" />,
            },
          },
        ],
      },
    ],
  },
];
export default permitRoutes;
